
import Excel from '../../assets/excel.svg';

const ExcelIcon = () => {
    return <img src={Excel} style={{ width: '24px' }} alt="Excel icon" />;
};

export default ExcelIcon;
